import styles from "./TermsAndConditions.module.scss";

export const TermsAndConditions = () => {
    return (
        <section className={styles.TermsAndConditions}>
            <h2 className={styles.title}>Terms and Conditions</h2>
            <p>
                <strong>Last Updated:</strong> August 28, 2025
            </p>

            <p>
                These Terms and Conditions ("Terms") govern your use of our
                website located at
                <a
                    href="https://torsunov.com/en" // /consultations
                    className="text-blue-600 underline"
                >
                    {" "}
                    torsunov.com/en/consultations
                </a>
                (the "Site") and the purchase of any digital products ("Digital
                Products") or online services ("Services") from Dr. Torsunov
                Corporation, a corporation registered in the state of Illinois,
                USA ("we," "us," "our").
            </p>

            <p>
                <strong>Client Agreement:</strong> By accessing our Site,
                creating an account, or placing an order for Digital Products or
                Services, you acknowledge that you have read, understood, and
                agree to be bound by these Terms in their entirety. A checkbox
                confirming your agreement will be required before you can
                complete a purchase. If you do not agree with these Terms,
                please do not use our Site or purchase our Digital Products or
                Services.
            </p>

            <h3>1. License and Access for Digital Products</h3>
            <ul>
                <li>
                    <strong>Grant of License:</strong> Upon purchase of a
                    Digital Product, we grant you a limited, non-exclusive,
                    non-transferable, and revocable license to access, download,
                    and use the purchased product for your personal,
                    non-commercial use only.
                </li>
                <li>
                    <strong>Restrictions:</strong> You agree not to copy,
                    modify, distribute, sell, transfer, rent, or sublicense any
                    Digital Product. The purchase of a Digital Product does not
                    transfer any intellectual property rights to you. All rights
                    not expressly granted are reserved by Dr. Torsunov
                    Corporation.
                </li>
            </ul>

            <h3>2. Refund Policy</h3>

            <h4>2.1. Refunds for Digital Products</h4>
            <ul>
                <li>
                    <strong>General Rule:</strong> Due to the immediate access
                    and irrevocable nature of Digital Products (such as ebooks,
                    templates, downloadable software, online courses), all sales
                    are considered final and non-refundable upon purchase.
                </li>
                <li>
                    <strong>Exceptions:</strong> A refund may be considered at
                    our sole discretion only in the following circumstances:
                    <ul>
                        <li>
                            If the digital file is corrupted and we are unable
                            to provide you with a functional replacement within
                            a reasonable timeframe.
                        </li>
                        <li>
                            If you have accidentally made a duplicate purchase
                            of the exact same product.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Process:</strong> To request a refund based on the
                    exceptions above, please contact our support team at
                    <a href="mailto:info@torsunov.com">
                        {" "}
                        info@torsunov.com
                    </a>{" "}
                    within 7 days of your purchase, providing your order number
                    and a detailed explanation of the issue.
                </li>
            </ul>

            <h4>2.2. Refunds for Online Services</h4>
            <ul>
                <li>
                    <strong>Cancellation Prior to Service Delivery:</strong> If
                    you cancel a scheduled Service (such as a consultation or
                    coaching session) at least 48 hours before the scheduled
                    start time, you are eligible for a full refund or credit.
                    Cancellations made with less than 48 hours' notice may be
                    subject to a cancellation fee of $50.00 (USD).
                </li>
                <li>
                    <strong>Satisfaction with Services Rendered:</strong>{" "}
                    Services that have already been rendered are generally
                    non-refundable. If you are unsatisfied with a Service you
                    have received, please contact us at
                    <a
                        href="mailto:info@torsunov.com"
                        className="text-blue-600 underline"
                    >
                        {" "}
                        info@torsunov.com
                    </a>{" "}
                    within 7 days of service completion to discuss your
                    concerns. We will work with you in good faith to find a
                    satisfactory resolution, which may include a partial refund
                    or a credit for future services at our sole discretion.
                </li>
            </ul>

            <h3>3. Tax Policy</h3>
            <ul>
                <li>
                    <strong>Sales Tax:</strong> Prices displayed on the Site are
                    exclusive of sales tax. We are required by law to collect
                    sales tax on sales to customers in states and jurisdictions
                    where we have an "economic nexus."
                </li>
                <li>
                    <strong>Calculation:</strong> The applicable sales tax will
                    be calculated based on the billing address you provide at
                    checkout and will be added to your final order total before
                    you confirm your purchase.
                </li>
                <li>
                    <strong>International Customers:</strong> For customers
                    outside of the United States, you are solely responsible for
                    any applicable taxes, such as VAT, levied by your country of
                    residence.
                </li>
            </ul>

            <h3>4. Privacy Policy</h3>
            <h4>4.1. Information We Collect</h4>
            <ul>
                <li>
                    <strong>Personal Identification Information:</strong> Name,
                    billing address, email address, and phone number when you
                    place an order.
                </li>
                <li>
                    <strong>Payment Information:</strong> Your payment details
                    are not stored by us. They are collected and processed
                    directly by our secure third-party payment processors (e.g.,
                    Stripe, PayPal).
                </li>
                <li>
                    <strong>Technical Information:</strong> IP address, browser
                    type, and device information through the use of cookies.
                </li>
            </ul>

            <h4>4.2. How We Use Your Information</h4>
            <ul>
                <li>
                    To process and fulfill your orders for Digital Products and
                    Services.
                </li>
                <li>
                    To provide you with access to your purchased digital
                    content.
                </li>
                <li>
                    To communicate with you about your order and for marketing
                    purposes (you may opt out at any time).
                </li>
                <li>To improve our Site and customer experience.</li>
            </ul>

            <h4>4.3. Data Sharing and Security</h4>
            <ul>
                <li>
                    We do not sell, trade, or rent your personal information.
                </li>
                <li>
                    We may share your information with trusted third parties who
                    assist us in operating our business (e.g., payment gateways,
                    email marketing platforms), so long as those parties agree
                    to keep this information confidential.
                </li>
                <li>
                    We implement appropriate security measures to protect
                    against unauthorized access or alteration of your personal
                    information.
                </li>
            </ul>

            <h3>5. Service Delivery and Acceptance</h3>
            <ul>
                <li>
                    <strong>Confirmation of Service Delivery:</strong> A Service
                    in the form of a digital consultation is considered fully
                    rendered by us and accepted by the Client at the moment the
                    scheduled online meeting concludes.
                </li>
                <li>
                    <strong>Period for Claims:</strong> If the Client does not
                    contact us at <em>[Your Support Email Address]</em> with a
                    specific claim within 48 hours from the moment the
                    consultation ends, the Service will be deemed fully
                    accepted.
                </li>
                <li>
                    <strong>Acceptance of Service:</strong> Upon completion of
                    the consultation, we will email the Client a link to a
                    service acceptance form. If the Client fails to confirm
                    within 3 business days and does not submit a claim, the
                    Service will be deemed accepted automatically.
                </li>
            </ul>

            <h3>6. Intellectual Property</h3>
            <p>
                All content on this Site, including text, graphics, logos,
                images, and our Digital Products, is the property of Dr.
                Torsunov Corporation and is protected by United States and
                international copyright laws.
            </p>

            <h3>7. Limitation of Liability</h3>
            <p>
                To the fullest extent permitted by law, Dr. Torsunov Corporation
                shall not be liable for any indirect, incidental, special, or
                consequential damages resulting from the use or inability to use
                our Site or from our Digital Products or Services.
            </p>

            <h3>8. Governing Law</h3>
            <p>
                These Terms shall be governed by and construed in accordance
                with the laws of the state of Illinois, USA, without regard to
                its conflict of law principles.
            </p>

            <h3>9. Changes to These Terms</h3>
            <p>
                We reserve the right to update or modify these Terms at any
                time. The "Last Updated" date at the top of this page will
                indicate the latest revision. Your continued use of the Site
                after any changes constitutes your acceptance of the new Terms.
            </p>

            <h3>10. Contact Us</h3>
            <address>
                Dr. Torsunov Corporation
                <br />
                155 N Harbor Dr, Chicago, IL - 60601
                <br />
                <a
                    href="mailto:info@torsunov.com"
                    className="text-blue-600 underline"
                >
                    info@torsunov.com
                </a>
            </address>
        </section>
    );
};
